import React from 'react';
import SearchBar from './components/SearchBar';
import {useFeatureServices, Content} from './use-feature-services';

export function App(): JSX.Element {
  const {
    'locale-service': languageService,
    'fa-content-service': contentService,
  } = useFeatureServices();

  const content: Content = contentService.content;
  const title = content.title;
  const searchType = content.searchType;
  const language = languageService.language;

  React.useEffect(() => console.log('React.version', React.version), []);

  return (
    <SearchBar
      language={language}
      title={title}
      searchType={searchType}
    />
  );
}
